import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../../mfe/MfeLoader";

export const Route = createFileRoute("/nhi-olcm/$")({
  component: NhiOlcmCatchAll,
});

function NhiOlcmCatchAll() {
  return <MfeLoader name="nhi-olcm" />;
}
